import React from 'react';
import moment from 'moment';
import { DATE_FORMAT_WITH_TIME } from 'common/const/common.const';
import { IStoreModel } from 'entities/Store/Store.models';
import { IOrderItemsModel, IOrderModel } from 'entities/Order/Order.models';
import { IPromoModel } from 'entities/Promo/Promo.models';
import { getOrderStatusText, rejectReasonText } from 'entities/Order/order.helper';
import { EPaymentMetodText, EStatisticStoreOrderStatus } from 'entities/Statistic/Statistic.models';

export const franchiseeOrdersTableConfig = [
  {
    title: 'Store Name',
    dataIndex: 'storeData',
    key: 'storeName',
    fixed: true,
    render: (storeData: IStoreModel) => <span>{storeData?.storeName}</span>,
  },
  {
    title: 'Order Number',
    dataIndex: 'code',
    key: 'code',
  },
  {
    title: 'Timestamp of Order',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (date: string) => <span>{moment(date).format(DATE_FORMAT_WITH_TIME)}</span>,
  },
  {
    title: 'Order Status',
    dataIndex: 'status',
    key: 'status',
    render: (orderStatus: string) => <span>{getOrderStatusText(orderStatus as EStatisticStoreOrderStatus)}</span>,
  },
  {
    title: 'Reject Reason',
    dataIndex: 'rejectReason',
    key: 'rejectReason',
    render: (rejectReason: string) => <span>{rejectReasonText(rejectReason, ' ')}</span>,
  },
  {
    title: 'Menu Item Name',
    dataIndex: 'items',
    key: 'items',
    render: (orderItems: IOrderItemsModel[]) => (
      <span>
        {orderItems.map((orderItem) => (
          <span key={orderItem.id}>
            <span>{orderItem.assetItemData.name}</span>
            <br />
          </span>
        ))}
      </span>
    ),
  },
  {
    title: 'Promo Used',
    dataIndex: 'promo',
    key: 'promo',
    render: (promo: IPromoModel) => <span>{promo?.name}</span>,
  },
  {
    title: 'Total',
    dataIndex: 'total',
    key: 'total_common',
    render: (total: number) => <span>P{total}</span>,
  },
  {
    title: 'Given Discount',
    dataIndex: 'discountTotal',
    key: 'discountTotal',
    render: (_: number | null, record: IOrderModel) => {
      if (!record.discountTotal) {
        return null;
      }

      return <span>P{(record.total - record.discountTotal).toFixed(2)}</span>;
    },
  },
  {
    title: 'Cash Paid',
    dataIndex: 'total',
    key: 'total_cash',
    render: (_: number, record: IOrderModel) => <span>P{record.discountTotal || record.total}</span>,
  },
  {
    title: 'Paid Via',
    dataIndex: 'checkoutSession',
    key: 'checkoutSession',
    render: (checkoutSession: any, record: IOrderModel) => {
      if (!checkoutSession) {
        if (record.items.every((item) => !!item.totalInBitecoins && item.totalInBitecoins > 0)) {
          return <span>{EPaymentMetodText.Bitecoins}</span>;
        }

        if (
          ![EStatisticStoreOrderStatus.PaymentAwaiting, EStatisticStoreOrderStatus.PaymentCancelled].includes(
            record.status as EStatisticStoreOrderStatus
          )
        ) {
          return <span>Cash</span>;
        }
      }

      if (checkoutSession) {
        return <span>{checkoutSession?.paymentMethod || 'Unknown'}</span>;
      }

      return <span>-</span>;
    },
  },
  {
    title: 'Coins Used',
    dataIndex: 'total',
    key: 'total_coins',
    render: (_: number, record: IOrderModel) => (
      <span>{record.items.some((item) => (item.totalInBitecoins || 0) > 0) ? 'Yes' : 'No'}</span>
    ),
  },
];
